// Telia Login
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_LOGOUT_SUCCEEDED = "AUTH_LOGOUT_SUCCEEDED";
export const AUTH_LOGOUT_FAILED = "AUTH_LOGOUT_FAILED";
export const AUTH_IS_AUTHENTICATED = "AUTH_IS_AUTHENTICATED";
export const AUTH_IS_AUTHENTICATED_SUCCEEDED = "AUTH_IS_AUTHENTICATED_SUCCEEDED";
export const AUTH_IS_AUTHENTICATED_FAILED = "AUTH_IS_AUTHENTICATED_FAILED";

// BankId Authentication
export const AUTH_BANK_ID_SET_IS_AVAILABLE = "AUTH_BANK_ID_SET_IS_AVAILABLE";
export const AUTH_BANK_ID_AUTHORIZE = "AUTH_BANK_ID_AUTHORIZE";
export const AUTH_BANK_ID_AVAILABLE = "AUTH_BANK_ID_AVAILABLE";
export const AUTH_BANK_ID_GRANT = "AUTH_BANK_ID_GRANT";
export const AUTH_BANK_ID_RESET = "AUTH_BANK_ID_RESET";
